import { render, staticRenderFns } from "./EduLayout.vue?vue&type=template&id=0fecc39a&scoped=true"
import script from "./EduLayout.vue?vue&type=script&lang=js"
export * from "./EduLayout.vue?vue&type=script&lang=js"
import style0 from "./EduLayout.vue?vue&type=style&index=0&id=0fecc39a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fecc39a",
  null
  
)

export default component.exports